import * as React from "react";
import { CurrencySymbolDictionary } from "../../../../../../../../react-core/Enums/Dictionaries/CurrencySymbolDictionary";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { PerformanceIncomeDataView } from "../../../../../../../../Wrap/Constants/Enums/Portfolio/Performance/PerformanceIncomeDataView";
import { Money } from "../../../../../../../../Wrap/Core/DataTypes/Money";
import { PerformanceIncomeDividendColumns } from "../../../../../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/PerformanceIncomeDividendColumns";
import { PerformanceIncomeInterestColumns } from "../../../../../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/PerformanceIncomeInterestColumns";
import { PerformanceIncomeTaxColumns } from "../../../../../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/PerformanceIncomeTaxColumns";
import { PerformanceIncomeModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/PerformanceIncomeModel";
import { Alert } from "../../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../../Shared/Entities/Constants/AlertConstants";
import { ITableConfig, Table } from "../../../../../../../Shared/Table/Table";
import { Contents } from "../../Insights/Resource/Contents";

interface IIncomeTableProps {
    data: PerformanceIncomeModel;
    tableView: PerformanceIncomeDataView;
    editorKey: string;
}
export const getIncomeInterestCol = (currencyCode: string): ITableConfig[] => {
    return [
        {
            title: "CCY",
            key: "BaseCcyAmount.Currency",
            render: (data, row, index) => {
                return CurrencySymbolDictionary.getStringMap(data);
            },
            tableFilter: PerformanceIncomeInterestColumns.CCY,
        },
        {
            title: "Date",
            key: "Date",
            render: (data, row, index) => {
                return JsonDateParser.getFormatDate(data, "dd/MM/yyyy");
            },
            tableFilter: PerformanceIncomeInterestColumns.Date,
            filterOption: { disableEdit: true },
        },
        {
            title: "Code",
            key: "FundCode",
            tableFilter: PerformanceIncomeInterestColumns.Code,
        },
        {
            title: "Description",
            key: "DisplayName",
            tableFilter: PerformanceIncomeInterestColumns.Description,
            filterOption: { disableEdit: true },
        },
        {
            title: "Narration",
            key: "Narration",
            tableFilter: PerformanceIncomeInterestColumns.Narration,
            filterOption: { disableEdit: true },
        },
        {
            title: "Gross",
            key: "Gross",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data: Money, row, index) => {
                return CurrencySymbolDictionary.getSymbol(data.Currency) + data.Amount.toFixed(2);
            },
            tableFilter: PerformanceIncomeInterestColumns.Gross,
            filterOption: { disableEdit: true },
        },
        {
            title: "Equalisation",
            key: "Equalisation",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data: Money, row, index) => {
                return CurrencySymbolDictionary.getSymbol(data.Currency) + data.Amount.toFixed(2);
            },
            tableFilter: PerformanceIncomeInterestColumns.Equalisation,
        },
        {
            title: "RWT",
            key: "Rwt",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data: Money, row, index) => {
                return CurrencySymbolDictionary.getSymbol(data.Currency) + data.Amount.toFixed(2);
            },
            tableFilter: PerformanceIncomeInterestColumns.RWT,
        },
        {
            title: "NET",
            key: "Net",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data: Money, row, index) => {
                return CurrencySymbolDictionary.getSymbol(data.Currency) + data.Amount.toFixed(2);
            },
            tableFilter: PerformanceIncomeInterestColumns.NET,
            filterOption: { disableEdit: true },
        },
        {
            title: "FX",
            key: "FxRate",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data: number, row, index) => {
                return data.toFixed(4);
            },
            tableFilter: PerformanceIncomeInterestColumns.FX,
        },
        {
            title: `${currencyCode} amount`,
            key: "BaseCcyAmount",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data: Money, row, index) => {
                return CurrencySymbolDictionary.getSymbol(data.Currency) + data.Amount.toFixed(2);
            },
            tableFilter: PerformanceIncomeInterestColumns.GBPAmount,
            filterOption: { disableEdit: true },
        },
    ];
};

export const getIncomeDividendCol = (currencyCode: string): ITableConfig[] => {
    return [
        {
            title: "CCY",
            key: "BaseCcyAmount.Currency",
            render: (data, row, index) => {
                return CurrencySymbolDictionary.getStringMap(data);
            },
            tableFilter: PerformanceIncomeDividendColumns.CCY,
        },
        {
            title: "Date",
            key: "Date",
            render: (data, row, index) => {
                return JsonDateParser.getFormatDate(data, "dd/MM/yyyy");
            },
            tableFilter: PerformanceIncomeDividendColumns.Date,
            filterOption: { disableEdit: true },
        },
        {
            title: "Code",
            key: "FundCode",
            tableFilter: PerformanceIncomeDividendColumns.Code,
        },
        {
            title: "Description",
            key: "DisplayName",
            tableFilter: PerformanceIncomeDividendColumns.Description,
            filterOption: { disableEdit: true },
        },
        {
            title: "Gross",
            key: "Gross",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data: Money, row, index) => {
                return CurrencySymbolDictionary.getSymbol(data.Currency) + data.Amount.toFixed(2);
            },
            tableFilter: PerformanceIncomeDividendColumns.Gross,
            filterOption: { disableEdit: true },
        },
        {
            title: "Equalisation",
            key: "Equalisation",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data: Money, row, index) => {
                return CurrencySymbolDictionary.getSymbol(data.Currency) + data.Amount.toFixed(2);
            },
            tableFilter: PerformanceIncomeDividendColumns.Equalisation,
        },
        {
            title: "RWT",
            key: "Rwt",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data: Money, row, index) => {
                return CurrencySymbolDictionary.getSymbol(data.Currency) + data.Amount.toFixed(2);
            },
            tableFilter: PerformanceIncomeDividendColumns.RWT,
        },
        {
            title: "NET",
            key: "Net",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data: Money, row, index) => {
                return CurrencySymbolDictionary.getSymbol(data.Currency) + data.Amount.toFixed(2);
            },
            tableFilter: PerformanceIncomeDividendColumns.NET,
            filterOption: { disableEdit: true },
        },
        {
            title: "FX",
            key: "FxRate",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data: number, row, index) => {
                return data.toFixed(4);
            },
            tableFilter: PerformanceIncomeDividendColumns.FX,
        },
        {
            title: `${currencyCode} amount`,
            key: "BaseCcyAmount",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data: Money, row, index) => {
                return CurrencySymbolDictionary.getSymbol(data.Currency) + data.Amount.toFixed(2);
            },
            tableFilter: PerformanceIncomeDividendColumns.GBPAmount,
            filterOption: { disableEdit: true },
        },
    ];
};

export const getIncomeTaxCol = (currencyCode: string): ITableConfig[] => {
    return [
        {
            title: "CCY",
            key: "TaxInBaseCcy.Currency",
            render: (data, row, index) => {
                return CurrencySymbolDictionary.getStringMap(data);
            },
            tableFilter: PerformanceIncomeTaxColumns.CCY,
        },
        {
            title: "Date",
            key: "Date",
            render: (data, row, index) => {
                return JsonDateParser.getFormatDate(data, "dd/MM/yyyy");
            },
            tableFilter: PerformanceIncomeTaxColumns.Date,
            filterOption: { disableEdit: true },
        },
        {
            title: "Code",
            key: "FundCode",
            tableFilter: PerformanceIncomeTaxColumns.Code,
        },
        {
            title: "Description",
            key: "DisplayName",
            tableFilter: PerformanceIncomeTaxColumns.Description,
            filterOption: { disableEdit: true },
        },
        {
            title: "Narration",
            key: "Narration",
            tableFilter: PerformanceIncomeTaxColumns.Narration,
            filterOption: { disableEdit: true },
        },
        {
            title: "Tax",
            key: "Tax",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data: Money, row, index) => {
                return CurrencySymbolDictionary.getSymbol(data.Currency) + data.Amount.toFixed(2);
            },
            tableFilter: PerformanceIncomeTaxColumns.Tax,
            filterOption: { disableEdit: true },
        },
        {
            title: "FX",
            key: "FxRate",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data: number, row, index) => {
                return data.toFixed(4);
            },
            tableFilter: PerformanceIncomeTaxColumns.FX,
        },
        {
            title: `Tax ${currencyCode}`,
            key: "TaxInBaseCcy",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data: Money, row, index) => {
                return CurrencySymbolDictionary.getSymbol(data.Currency) + data.Amount.toFixed(2);
            },
            tableFilter: PerformanceIncomeTaxColumns.TaxGBP,
            filterOption: { disableEdit: true },
        },
    ];
};
export const IncomeTable = (props: IIncomeTableProps) => {
    if (!props.data) {return null;}
    if (props.data.details.length == 0)
        {return <Alert alertType={AlertType.Warning} message={Contents.noDataErrorMessagePerformanceIncom} />;}

    const [currentPage, setCurrentPage] = React.useState(1);
    const [tableData, setTableData] = React.useState(props.data.details.slice(0, 49));

    const currencyCode = CurrencySymbolDictionary.getStringMap(props.data.BaseCcy);
    let tableColumns = [];
    switch (props.tableView) {
        case PerformanceIncomeDataView.Interest:
        case PerformanceIncomeDataView.AccumulationFundInterestNonCash:
            tableColumns = getIncomeInterestCol(currencyCode);
            break;
        case PerformanceIncomeDataView.Dividends:
        case PerformanceIncomeDataView.EquityDividends:
        case PerformanceIncomeDataView.AccumulationFundDistributionsNonCash:
            tableColumns = getIncomeDividendCol(currencyCode);
            break;
        case PerformanceIncomeDataView.Tax:
            tableColumns = getIncomeTaxCol(currencyCode);
            break;
    }

    return (
        <Table
            data={tableData}
            colEditorKey={props.editorKey}
            col={tableColumns}
            TotalBody={
                props.tableView == PerformanceIncomeDataView.Tax
                    ? [
                          { data: "Total", colIndex: 0 },
                          {
                              data:
                                  CurrencySymbolDictionary.getSymbol(props.data.Total.Tax.Currency) +
                                  props.data.Total.Tax.Amount.toFixed(2),
                              colIndex: 5,
                              tfTdCssWrapper: "cell-right",
                          },
                          {
                              data:
                                  CurrencySymbolDictionary.getSymbol(props.data.Total.TaxInBaseCcy.Currency) +
                                  props.data.Total.TaxInBaseCcy.Amount.toFixed(2),
                              colIndex: 7,
                              tfTdCssWrapper: "cell-right",
                          },
                      ]
                    : props.tableView == PerformanceIncomeDataView.Dividends ||
                      props.tableView == PerformanceIncomeDataView.AccumulationFundDistributionsNonCash ||
                      props.tableView == PerformanceIncomeDataView.EquityDividends
                    ? [
                          { data: "Total", colIndex: 0 },
                          {
                              data:
                                  CurrencySymbolDictionary.getSymbol(props.data.Total.Gross.Currency) +
                                  props.data.Total.Gross.Amount.toFixed(2),
                              colIndex: 4,
                              tfTdCssWrapper: "cell-right",
                          },
                          {
                              data:
                                  CurrencySymbolDictionary.getSymbol(props.data.Total.Equalisation.Currency) +
                                  props.data.Total.Equalisation.Amount.toFixed(2),
                              colIndex: 5,
                              tfTdCssWrapper: "cell-right",
                          },
                          {
                              data:
                                  CurrencySymbolDictionary.getSymbol(props.data.Total.Rwt.Currency) +
                                  props.data.Total.Rwt.Amount.toFixed(2),
                              colIndex: 6,
                              tfTdCssWrapper: "cell-right",
                          },
                          {
                              data:
                                  CurrencySymbolDictionary.getSymbol(props.data.Total.Net.Currency) +
                                  props.data.Total.Net.Amount.toFixed(2),
                              colIndex: 7,
                              tfTdCssWrapper: "cell-right",
                          },

                          {
                              data:
                                  CurrencySymbolDictionary.getSymbol(props.data.Total.BaseCcyAmount.Currency) +
                                  props.data.Total.BaseCcyAmount.Amount.toFixed(2),

                              colIndex: 9,
                              tfTdCssWrapper: "cell-right",
                          },
                      ]
                    : [
                          { data: "Total", colIndex: 0 },
                          {
                              data:
                                  CurrencySymbolDictionary.getSymbol(props.data.Total.Gross.Currency) +
                                  props.data.Total.Gross.Amount.toFixed(2),
                              colIndex: 5,
                              tfTdCssWrapper: "cell-right",
                          },
                          {
                              data:
                                  CurrencySymbolDictionary.getSymbol(props.data.Total.Equalisation.Currency) +
                                  props.data.Total.Equalisation.Amount.toFixed(2),
                              colIndex: 6,
                              tfTdCssWrapper: "cell-right",
                          },
                          {
                              data:
                                  CurrencySymbolDictionary.getSymbol(props.data.Total.Rwt.Currency) +
                                  props.data.Total.Rwt.Amount.toFixed(2),
                              colIndex: 7,
                              tfTdCssWrapper: "cell-right",
                          },
                          {
                              data:
                                  CurrencySymbolDictionary.getSymbol(props.data.Total.Net.Currency) +
                                  props.data.Total.Net.Amount.toFixed(2),
                              colIndex: 8,
                              tfTdCssWrapper: "cell-right",
                          },

                          {
                              data:
                                  CurrencySymbolDictionary.getSymbol(props.data.Total.BaseCcyAmount.Currency) +
                                  props.data.Total.BaseCcyAmount.Amount.toFixed(2),
                              colIndex: 10,
                              tfTdCssWrapper: "cell-right",
                          },
                      ]
            }
            needPagination={{
                pageSize: 50,
                totalNumOfResult: props.data.details.length,
                isShowPerPageOptions: true,
                onPaginationChange: (pageIndex, pageSize) => {
                    const max = pageIndex * pageSize - 1;
                    const min = pageSize * (pageIndex - 1);
                    setCurrentPage(pageIndex);
                    setTableData(props.data.details.slice(min, max));
                },
                currentPage: currentPage,
            }}
        />
    );
};
